module.exports = __webpack_public_path__ + "assets/assets/images/icons/check-green.cb983f2d.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/check-green.svg
// module id = 297
// module chunks = 0